import { guidGenerator } from '../helpers/guid'

export function getElementByElementOrId(id_or_element) {
    if (typeof id_or_element === 'string') { return document.getElementById(id_or_element) };
    if ( id_or_element instanceof Element ) { return id_or_element };
    return;
}

export function identifyElement(element) {
    if (!element) { return null }
    let id = element.id;
    if (id) return id;
    do { id = 'anonymous_element_' + guidGenerator() } while ( document.getElementById(id) );
    element.id = id;
    return id;
}

export function hasChildElement(element) {
    return element.children.length !== 0;
}